import axios from 'axios';
import { SubjectStudents } from 'src/models';

import { BASE_URL } from './config';
// Updated endpoint from '/api/alumnos' to '/api/students'
const ENDPOINT = '/api/students';

export function getStudents(plan: string, subjectId: string, group: string) {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN,
    },
  });

  return apiClient.get<SubjectStudents>(
    `${ENDPOINT}/${plan}/${subjectId}/${group}`
  );
}
